import React from 'react';
import { getIn } from 'seamless-immutable';
import NearStore from '@catalogo/ui-americanas-mobile-near-store';
import Freight from '@catalogo/ui-americanas-desktop-freight';

export const DeliveryFlow = props => {
  const { currentSku } = props;
  const offer = getIn(currentSku, ['offers', 'result', '0']);
  const isO2O = getIn(offer, ['seller', 'id']) === '33014556000196';

  if (isO2O) {
    return <NearStore {...props} />;
  }

  return <Freight {...props} />;
};

export default DeliveryFlow;
